<template>
  <div id="app">
    <!--<a href="javascript:;" @click="$store.dispatch('showHF')">显示</a>-->
    <!--<a href="javascript:;" @click="$store.dispatch('hideHF')">隐藏</a>-->
    <MyHeader  v-show="$store.getters.getShowHeader"></MyHeader>
    <router-view/>
    <MyFooter v-show="$store.getters.getShowFooter"></MyFooter>
  </div>
</template>

<script>
  import MyHeader from './components/MyHeader.vue'
  import MyFooter from './components/MyFooter.vue'
  export default {
    name: 'app',
    components:{
      MyHeader,
      MyFooter
    },
  }
</script>



// WEBPACK FOOTER //
// src/App.vue